// API URLs
export const API_URL = import.meta.env.VITE_API_URL || 'https://api.jeridschool.com/server'
export const API_AI_URL = import.meta.env.VITE_API_AI_URL
export const API_TIMETABLE_URL = import.meta.env.VITE_API_TIMETABLE_URL || 'https://api.jeridschool.com/timetable'

// Other constants
export const MAX_DECKS_PER_USER = 3
export const MAX_CARDS_PER_DECK = 50
